<template>
  <div class="GlobalTable">
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="this.page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="线上评估项" slot="storeAction" align="center">
        <template slot-scope="{ row }">
          <span @click="online(row)" style="color:#0981FF; cursor: pointer;">查看</span>
        </template>
      </el-table-column>
      <el-table-column label="系统真实估价/商户原始估价" slot="storePrice" align="center">
        <template slot-scope="{ row }">
          <span>{{row.fenhaoPrice}}/{{ row.companyFactorPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="扣减利润" slot="allCompanyRebate" align="center">
        <template slot-scope="{ row }">
          <span>{{row.allCompanyRebate?row.allCompanyRebate:'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="扣减员工红包" slot="allStaffReward" align="center">
        <template slot-scope="{ row }">
          <span>{{row.allStaffReward?row.allStaffReward:'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户查看预估价" slot="userShowThisPrice" align="center">
        <template slot-scope="{ row }">
          <span>{{row.userShowThisPrice}}</span>
          <div v-if="row.showPriceType !=='01'">({{row.leftSideShowPrice||0}}~{{row.rightSideShowPrice||0}})</div>
        </template>
      </el-table-column>
      <el-table-column label="申请议价原因" slot="storeImg" align="center">
        <template slot-scope="{ row }">
          <span @click="examine(row)" style="color:#0981FF; cursor: pointer;">查看</span>
        </template>
      </el-table-column>

      <el-table-column width="200" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="handleBtn(row, 'edit')">编辑</el-button>
          <el-button size="mini" type="danger" round @click="handleBtn(row, 'del')">删除</el-button>
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 二维码弹窗 -->
    <el-dialog title="线上评估项" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px"
      @closed="dialogVisible">
      <div>
        <span class="dialog-tip" style="margin-right:60px">机型名称：{{ goodsName }}</span>
        <span class="dialog-tip">线上预估金额：￥{{userShowThisPrice?userShowThisPrice:'--'}}</span>
      </div>
      <div class="merit_content">
        <div class="max_box" v-for="(i, index) in yuanData" :key="index"><span>{{ i.optionKeyValueText +"："}}</span> <span>{{ i.optionValueText }}</span> </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="dialogVisible = false">确定</el-button>
        <!-- <el-button @click.native="handleClose">取消</el-button> -->
      </span>
    </el-dialog>
    <!--弹框-->
    <el-dialog title="申请议价原因" :visible.sync="dialogQuotatVisible" :close-on-click-modal="false" width="800px"
      @closed="handleDialogClosed">
      <span class="dialog-tip">旧机优势：</span>
      <div class="center_con">
        <span class="cen_box" v-for="(i, index) in priceData.phoneAdvantages" :key="index">{{ i }}</span>
      </div>
      <span class="dialog-tip">其他说明：</span>
      <div class="textarea">
        {{ priceData.otherInstructions?priceData.otherInstructions:'无' }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="dialogQuotatVisible = false">确定</el-button>
        <!-- <el-button @click.native="handleClose">取消</el-button> -->
      </span>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="
      () => {
        showViewer = false;
      }
    " :url-list="imgList" />
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { http } from "../../../utils/request/newIndex"
import _api from "@/utils/request";
export default {
  name: "Table",
  mixins: [MinXinRequest],
  components: { ElImageViewer },
  data() {
    return {
      // 店员弹窗
      formInline: {
        staffName: '',
        staffMobile: '',
      },
      priceData:{},
      dialogTip: "",
      storeId: '',
      actionType: "",
      staffVisible: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      DialogDataList: [],
      DialogTableColumns: [
        { label: '店员姓名', prop: 'staffName' },
        { slotName: 'staffType' },
        { label: '联系电话', prop: 'staffMobile' },
      ],
      //////////列表
      seachDataList: [],
      //弹窗
      dialogVisible: false, // 弹框的出现与否
      ////////
      tableColumns: [
        { label: "机型名称", prop: "goodsName" },
        // { label: "用户名称", prop: "userName" },
        { label: "用户手机号", prop: "userPhone" },
        { slotName: "storeAction" },
        { slotName: "storePrice" },
        { slotName: "allCompanyRebate" },
        { slotName: "allStaffReward" },
        { slotName: "userShowThisPrice" },
        // { label: "用户查看预估价", prop: "userShowThisPrice" },
        { label: "用户议价价格", prop: "expectedPrice" },
        { slotName: "storeImg" },
        { label: "申请时间", prop: "createTime" },
        // { slotName: "operation" }
      ],
      // 添加编辑门店弹窗
      editId: '',
      storeDiaTitle: '',
      ruleForm: {
        storeName: '',
        storeCode: '',
        storeAddress: '',
      },
      rules: {
        storeName: [
          { required: true, message: '请输入门店名称', trigger: 'change' }
        ],
        storeAddress: [
          { required: true, message: '请输入门店地址', trigger: 'change' }
        ],
      },
      dialogTitle: '',
      showViewer: false,
      imgList: [],
      dialogStoreVisible: false,
      //////////////报价设置弹窗
      dialogQuotatVisible: false,
      quoteList: [],//报价弹窗数组
      DialogCode: false,
      Switchparams: {},
      yuanData:[],
      userShowThisPrice:"",
      goodsName:""
      
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams
    },
    storeAddEdit() {
      return this.$store.state.tagsView.storeAddEdit
    },
    storeExcel() {
      return this.$store.state.tagsView.storeExcel
    },
  },
  created() {
    this.handleCurrentChange(1);
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal,'+++++')
      this.handleCurrentChange()
    },
    storeAddEdit(newVal) {
      if (newVal === 'add') {
        this.storeDiaTitle = '添加'
        this.dialogStoreVisible = true
        this.ruleForm.storeAddress = ''
        this.ruleForm.storeCode = ''
        this.ruleForm.storeName = ''
      } else {
        this.storeDiaTitle = '编辑'
      }
    },
    storeExcel(newVal) {
      console.log(newVal, 'storeExcel')
      if (newVal == 'storeExcel') {
        this.handleCurrentChange(1);
      }
    },
    dialogStoreVisible(newVal) {
      if (newVal === false) {
        this.$store.commit('tagsView/STORE_ADDEDIT', 'edit')
      }
    }
  },
  methods: {
    handleDialogClosed() {
      this.dialogQuotatVisible = false;
      this.handleCurrentChange();
    },
    //查看优势原因
    examine(row) {
      this.dialogQuotatVisible = true
      this.priceData=row
      console.log(row);
    },
    online(row) {
      console.log(row);
      http.assessmentInfo({assessRecordId:row.assessRecordId}).then((res)=>{
        console.log(res);
        this.yuanData=res.data
        this.dialogVisible = true
        this.userShowThisPrice=row.userShowThisPrice
        this.goodsName=row.goodsName
      })

      
    },
    // //弹窗取消
    handleClose() {
      this.dialogQuotatVisible = false;
    },
    //弹窗确定
    handleSuccess() {
      if (this.actionType == 'del') {
        http.deleteAdverts({ id: this.storeId }).then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogQuotatVisible = false;
          }
        });
      } else {
        http.upOrDownAdverts(this.Switchparams).then(res => {
          console.log(res)
          if (res.code == 1) {
            this.$message.success(res.msg)
            this.dialogQuotatVisible = false
          } else {
            this.$message.error(res.msg)
          }
          this.handleCurrentChange()
        })
      }
    },
    // 查看示例图大图
    seeSampleImage(row) {
      this.imgList = [];
      this.showViewer = true;
      this.imgList.push(row.adImg);
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(val)
      // const baseRequest = {
      //   storeManager: this.SeachParams.storeManager,
      //   storeManagerPhone: this.SeachParams.staffMobile,
      //   storeName: this.SeachParams.storeName,
      //   pageNum: val ? val : this.SeachParams.pageNum,
      //   pageSize: 10,
      // };
      const baseRequest = {
        "userName": this.SeachParams.userName,
        "userPhone": this.SeachParams.userPhone,
        "endTime": this.SeachParams.endTime,
        "pageNum": val ? val : this.SeachParams.pageNum,
        "pageSize": 10,
        "startTime": this.SeachParams.startTime
      }
      this.$emit('handleCurrentChange', val)
      http.expectedList(baseRequest).then(res => {
        if (res.code === 1) {
          console.log(res)
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.$store.commit("tagsView/POST_STAFF", this.seachDataList);
          this.$store.commit('tagsView/STORE_EXCEL', 'false')
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 表格按钮操作
    handleBtn(row, type) {
      console.log("表格操作", type, row);
      if (type == 'edit') {
        this.$router.push({
          path: "/OnlinreyService/addAds",
          query: { type: "edit", id: row.id },
        });
      } else if (type == 'del') {
        this.dialogTip = "确认要删除此广告？"
        this.actionType = "del"
        this.storeId = row.id
        this.dialogQuotatVisible = true
      }
    },
    //启用/禁用账号
    handleSwitch(row) {
      this.actionType = ""
      this.dialogTip = " 确认要执行该操作吗？"
      this.Switchparams = {
        id: row.id,
        status: row.isEnable,
      }
      this.dialogQuotatVisible = true
      console.log(this.Switchparams);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  /deep/ .form_input .el-input__inner {
    height: 30px !important;
  }

  .dialog-tip {
    font-size: 16px;
  }

  .center_con {
    margin: 20px 20px 10px 20px;
    display: flex;
    flex-wrap: wrap;

    .cen_box {
      border: 1px solid #C1D1FF;
      border-radius: 20px;
      padding: 10px 20px;
      margin-right: 20px;
      margin-bottom: 20px;
    }

  }
  .merit_content{
    margin: 20px 0 0 0;
    display: flex;
    flex-wrap: wrap;
    .max_box{
        min-width:300px;
        //  height: 50px;
         border: 1px solid #000000;
         line-height: 50px;
         padding: 0 10px;
         margin: 0 20px 20px 0;
    }
  }

  .textarea {
    margin: 20px 0;
    border: 1px solid #C1D1FF;
    border-radius: 10px;
    height: 100px;
    padding: 10px;
  }

  .widQus {
    width: 96%;
    margin: 15px auto;
  }

  .qustion-top {
    display: flex;
    align-items: center;
    height: 20px;
    margin-bottom: 15px;

    img {
      width: 18px;
      object-fit: contain;
      margin-right: 5px;
    }

    div {
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      color: #FF687B;
      line-height: 0px;
    }
  }

  .box-qustion {
    // min-height: 276px;
    max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;
    background: #F5F5F5;
    border-radius: 4px;
  }

  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .qustion-item {
    padding-bottom: 10px;

    .el_input_item {
      width: 100px !important;
    }

    /deep/ .el-input__inner {
      height: 35px !important;
    }

    .left {
      margin: 20px 50px 0 10px;
    }

    .right {
      margin: 20px 10px 0 0;
    }

    .text {
      margin-right: 5px;
    }
  }

  .img_code {
    width: 200px;
    height: 200px;
    margin: 20px auto;

    img {
      width: 100%;
      object-fit: contain;
    }
  }


  /*修改滚动条样式*/
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-border-radius: 6px;
    width: 8px;
    background: white;
  }

  ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    width: 5px;
    background-color: #0981FF;
    -webkit-border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: #0981FF;
    -webkit-border-radius: 6px;
    -webkit-border-radius: 6px;
  }

  .none-Data {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 22px;
    color: #666;
  }
}
</style>
